import { Grid, IconButton, Tooltip } from "@mui/material";
import { useEffect, useReducer } from "react"
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next"
import CustomAlert from "../../componentes/alerts/CustomAlert"
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import InputField from "../../componentes/form-fields/InputField/InputField";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer"
import ClientControlService from "./ClientControlService"
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import { DefaultDatagrid } from "../../componentes/datagrid/DefaultDatagrid";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import DefaultChip from '../../componentes/chip/DefaultChip';
import { Typography } from "@material-ui/core";
import ColorPalletSketch from "./ColorPaletteSketch";
import { ImageUploadCard } from "../../componentes/DragNDrop/ImageUploadCard";
import { FaInfoCircle } from "react-icons/fa";


const columnsClient = (t) => [
    { field: "id", flex: 0.5, visible: false },
    {
        field: "clientName",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="clientName" name="company" />;
        },
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="grey"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.clientName}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "socialReason",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="socialReason" name="company" />;
        },
        flex: 1
    },
    {
        field: "cnpj",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="cnpj" name="cnpj" />;
        },
        flex: 1,
        template: (props) => {
            return (
                <>
                    {props.cnpj ?
                        <DefaultChip
                            style="standard"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.cnpj}
                            </Typography>}
                        />
                        : null}
                </>
            )
        }
    },
    {
        field: "color",
        textAlign: "center",
        flex: 1,
        headerTemplate: () => {
            return (
                <IconLabelSwitch
                    isHeader={true}
                    labelName="clientColorCode"
                    name="palette"
                />
            );
        },
        template: (props) => {
            return props.color ? (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px"
                    }}
                >
                    <div
                        style={{
                            width: 18,
                            height: 18,
                            borderRadius: 4,
                            backgroundColor: props.color,
                            border: "1px solid #ccc"
                        }}
                    />
                    <Typography variant="body3">
                        {props.color}
                    </Typography>
                </div>
            ) : null;
        }
    },
    {
        field: "status",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="status" />;
        },
        flex: 0.5,
        template: (props) => {
            return (
                <>
                    {props.status ? (
                        <IconSwitch name="active" />
                    ) : (
                        <IconSwitch name="canceled" />
                    )}
                </>
            );
        },
    },
];

export const ClientRegister = ({ updateId }) => {

    const { t } = useTranslation();
    const { control } = useForm();
    const userId = sessionStorage.getItem("userId");

    const initialState = {
        id: 0,
        clientName: "",
        socialReason: "",
        cnpj: "",
        ClientRows: [],
        img: "",
        loggedUserId: userId,
        status: 1,
        idPrinter: 0,
        success: false,
        error: false,
        color: ""
    };

    const reducer = (state, action) => {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case "clear":
                return initialState
            case 'success':
                return { ...state, success: true, error: false }
            case 'error':
                return { ...state, success: false, error: true }
            case 'close_alert':
                return { ...state, success: false, error: false }
            default:
                return new Error();
        }
    }

    const [ClientControl, dispatch] = useReducer(reducer, initialState);

    const { id, clientName, socialReason, cnpj, status, idPrinter, color, img } = ClientControl
    const { success, error, ClientRows, ...data } = ClientControl

    useEffect(() => {
        updateId({ id: id })
    }, [id])

    const handleChange = (event) => {
        const { name, value, selectionStart } = event.target;
        dispatch({ type: "update", data: { [name]: value } });
    };

    const handleSearch = () => {
        ClientControlService
            .getClient(data)
            .then((response) => {
                if (response.status === 200) {
                    dispatch({ type: 'update', data: { ClientRows: response.data } })
                }
            })
            .catch((e) => dispatch({ type: 'update', data: { ClientRows: [] } }));
    }
    const canSave = () => clientName !== "" && cnpj !== "" && status !== 2;

    const handleSaveUpdate = () => {
        if (canSave()) {
            if (id) {
                ClientControlService
                    .updateClient(data)
                    .then((response) => {
                        if (response.status === 200) {
                            dispatch({ type: 'success' })
                            handleSearch();
                        }
                    })
                    .catch((e) => dispatch({ type: 'error' }));
            }
            else {
                ClientControlService
                    .createClient(data)
                    .then((response) => {
                        if (response.status === 200) {
                            dispatch({ type: 'update', data: { success: true, error: false, id: response.data.id, message: t("noDataExport") } })
                            handleSearch();
                        }
                    })
                    .catch((e) => dispatch({ type: 'error' }));
            }
        } else {
            dispatch({ type: 'error' })
        }

    }

    const handleCellClickClient = (data) => {
        dispatch({
            type: 'update', data: {
                id: data.id,
                clientName: data.clientName,
                socialReason: data.socialReason,
                cnpj: data.cnpj,
                status: data.status,
                img: data.img,
                color: data.color
            }
        })
    }

    useEffect(() => {
        handleSearch();
    }, [])

    // CBernardo - 17/06/2026 - Nova função para CNPJ Alfanumérico
    const handleChangeCNPJ = (event) => {
        let value = event.target.value
            .toUpperCase()
            .replace(/[^A-Z0-9]/g, "");

        // REGRA: Dígitos verificadores (13 e 14) só podem ser números
        if (value.length > 12) {
            const dv = value.substring(12, 14);

            if (/[^\d]/.test(dv)) {
                // impede entrada de letras no DV
                return;
            }
        }

        const formatted = formatCNPJ(value);

        dispatch({
            type: "update",
            data: { cnpj: formatted }
        });
    };

    const formatCNPJ = (value) => {
        const cnpj = value
            .toUpperCase()
            .replace(/[^A-Z0-9]/g, "")
            .substring(0, 14);

        if (cnpj.length <= 2) {
            return cnpj;
        }

        if (cnpj.length <= 5) {
            return `${cnpj.substring(0, 2)}.${cnpj.substring(2)}`;
        }

        if (cnpj.length <= 8) {
            return `${cnpj.substring(0, 2)}.${cnpj.substring(2, 5)}.${cnpj.substring(5)}`;
        }

        if (cnpj.length <= 12) {
            return `${cnpj.substring(0, 2)}.${cnpj.substring(2, 5)}.${cnpj.substring(5, 8)}/${cnpj.substring(8)}`;
        }

        return `${cnpj.substring(0, 2)}.${cnpj.substring(2, 5)}.${cnpj.substring(5, 8)}/${cnpj.substring(8, 12)}-${cnpj.substring(12, 14)}`;
    };
    // Fim - CBernardo - 17/06/2026 - Nova função para CNPJ Alfanumérico

    const handleReloadImage = () => {
        ClientControlService
            .getClient(data)
            .then((response) => {
                if (response.status === 200) {
                    debugger;
                    dispatch({
                        type: "update",
                        data: {
                            img: response.data[0].img
                        }
                    });
                }
            })
            .catch(() => {
                dispatch({ type: "error" });
            });
    };

    return (
        <>
            <DefaultScreenAccordion
                title={"client"}
                isRegister
                fields={
                    <GridItemContainer>
                        <CustomAlert
                            success={success}
                            error={error}
                            handleCloseAlert={() => dispatch({ type: 'close_alert' })}
                        />
                        <Grid item xs={id !== 0 ? 7 : 12} sm={id !== 0 ? 8 : 12} md={id !== 0 ? 10 : 12}>
                            <GridInputRow>
                                <Grid item xs={12} sm={6} md={3}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="company" labelName="clientName" />
                                        }
                                        name="clientName"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={clientName}
                                        inputProps={{ maxLength: 50 }}
                                        error={error && clientName === ""}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="company" labelName="socialReason" />
                                        }
                                        name="socialReason"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={socialReason}
                                        inputProps={{ maxLength: 150 }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    {/* CBernardo - 17/06/2026 - Função antiga de CNPJ */}
                                    {/* <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="cnpj" labelName="cnpj" />
                                        }
                                        name="cnpj"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        mask="99.999.999/9999-99"
                                        value={cnpj}
                                        inputProps={{ maxLength: 18 }}
                                        error={error && cnpj === ""}
                                    /> */}
                                    {/* Fim - CBernardo - 17/06/2026 - Função antiga de CNPJ */}

                                    {/* CBernardo - 17/06/2026 - Nova função para CNPJ Alfanumérico */}
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="cnpj" labelName="cnpj" />
                                        }
                                        name="cnpj"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChangeCNPJ}
                                        value={cnpj}
                                        inputProps={{ maxLength: 18 }}
                                        error={error && cnpj === ""}
                                    />
                                    {/* Fim - CBernardo - 17/06/2026 - Nova função para CNPJ Alfanumérico */}
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <DefaultAutocomplete
                                        name={"status"}
                                        onChange={handleChange}
                                        value={status}
                                        label={t("status")}
                                        defaultSize
                                        items={[
                                            { id: 0, name: t("canceled"), status: 1 },
                                            { id: 1, name: t("active"), status: 1 },
                                            { id: 2, name: t("all"), status: 1 },
                                        ]}
                                        error={error && status === 2}
                                    />
                                </Grid>
                                <Grid item xs={6} sm={6} md={4}>
                                    <ColorPalletSketch
                                        colour={color}
                                        name="color"
                                        label={t("clientColorCode")}
                                        control={control}
                                        onChange={handleChange}
                                        error={error && color === ""}
                                    />
                                </Grid>
                                {id !== 0 && (
                                    <Grid item xs={12} sm={6} md={6}>
                                        <Typography variant="subtitle1" style={{ fontWeight: 400, marginBottom: 8 }}>
                                            {t("import")}
                                        </Typography>
                                        <Tooltip
                                            title={
                                                <Typography>
                                                    {t("clientLogo")}
                                                </Typography>
                                            }
                                        >
                                            <IconButton style={{ marginLeft: "150px" }}>
                                                <FaInfoCircle color="#29438D" />
                                            </IconButton>
                                        </Tooltip>
                                        <ImageUploadCard
                                            id={id}
                                            userId={userId}
                                            uploadCallBack={handleReloadImage}
                                            isRegister
                                            iconBase64={img}
                                            endPoint="Client/CustomFileUploaderClient"
                                            endPointremove="CustomFileUploaderClientLogo"
                                            allowedExtensions=".png, .jpg, .jpeg, .webp"
                                            allowedTypes={["png", "jpg", "jpeg", "webp"]}
                                        />
                                    </Grid>
                                )}
                            </GridInputRow>
                        </Grid>

                        <SearchClearSaveRow
                            onClickSearch={handleSearch}
                            onClickClear={() => dispatch({ type: 'clear' })}
                            onClickSave={handleSaveUpdate}
                        />
                        {(ClientRows.length > 0) ? (
                            <GridInputRow>
                                <Grid item xs={12}>
                                    <DefaultDatagrid
                                        columns={columnsClient(t)}
                                        dataSource={ClientRows}
                                        allowPaging={true}
                                        cellSelected={(args, grid) =>
                                            handleCellClickClient(args.data)
                                        } />
                                </Grid>
                            </GridInputRow>
                        ) : null}
                    </GridItemContainer>
                } />
        </>
    );
}